export default __webpack_public_path__ + "static/media/27-1_building.a0f5e6ec.svg";